export default {
  RESTART: 'Начать заново',
  ATTENTION_CLEAN_DATA: 'Внимание! Все данные будут удалены безвозвратно. Вы действительно хотите начать заново?',
  SELECT_CONTAINER_TYPE: 'Выберите тип контейнера',
  SELECT_CONTAINER_DESCRIPTION: 'Перед началом  оформления заявки необходимо выбрать тип базового контейнера. Внимание! Изменить тип контейнера после создания проекта нельзя!',
  LABEL_CONTINUE: 'Продолжить',
  LABEL_CANCEL: 'Отмена',
  LABEL_SEND: 'Отправить',
  LABEL_SKIP_ALL: 'Пропустить все',
  LABEL_NEXT: 'Далее',
  LABEL_VOLUME: 'Объём',
  LABEL_WIDTH: 'Ширина',
  LABEL_HEIGHT: 'Высота',
  LABEL_LENGTH: 'Длина',
  LABEL_EXT_FINISHING: 'Внешняя отделка',
  LABEL_INT_FINISHING: 'Внутренняя отделка',
  LABEL_WALLS: 'Стены',
  LABEL_COATING: 'Покрытие',
  LABEL_FLOOR: 'Пол',
  LABEL_MATERIAL: 'Материал',
  LABEL_ADDITIONAL: 'Доп. Элементы',

  LABEL_TYPE: 'Тип',
  LABEL_SIZE: 'Размер',
  LABEL_TOP_AND_BOTTOM: 'Нижняя и верхнии части',
  LABEL_TOP_PART: 'Верхняя часть',
  LABEL_COLOR: 'Цвет',
  LABEL_LOCKS: 'Замки',
  CLOSER: 'Доводчик',
  LATTICE: 'Решетка',
  ROLLER_SHUTTERS: 'Рольставни',

  COLOR_WHITE: 'Белый',
  LAMINATION: 'Ламинация',

  COST_POSTFIX: '₽',

  FREE: 'бесплатно',
  FIRST_LOCK: '1-й замок',
  SECOND_LOCK: '2-й замок',
  INSIDE_LOCK: 'Внутр. засов',

  REPLACE_LEATHER_WITH_METAL: 'Замена дермантина металом',

  CARCASS_FORCE: 'Усиление каркаса',
  CARCASS_COLOR: 'Цвет каркаса',
  CARCASS_COLOR_DESCRIPTION: 'Изменение цвета каркаса приминяется ко всему проекту',

  WALLS_MATERIAL_DESCRIPTION: 'Изменение материала стен приминяется ко всему проекту',
  FLOOR_MATERIAL_DESCRIPTION: 'Изменение покрытия пола приминяется ко всему проекту',

  MOBILE_POPUP_ATTENTION_TITLE: 'Конфигуратор Kraus-blocks.ru',
  MOBILE_POPUP_ATTENTION_DESCRIPTION: 'Для удобного использования конфигуратора, пожалуйста, откройте его на настольном компьютере или ноутбуке.',
  MOBILE_POPUP_ATTENTION_LINK_TEXT: 'Перейти на основной сайт kraust.ru',
  PROJECT_SENT: 'Заявка успешно отправлена',
  PROJECT_SENT_DESCRIPTION: 'Заявка (PDF) и ссылка для ее редактирования отправлены на почту',
  SEND_PROJECT_TO_EMAIL: 'Отправить проект на Email',
  SEND_PROJECT_TO_EMAIL_DESCRIPTION:'Вам на почту придет PDF-файл с вашей Заявкой и ссылка на ее редактирование. Вы сможете вернуться к редактированию Заявки в любое время, достаточно перейти по ссылке в почте.',
  WITHOUT_SURCHARGE: 'без доплаты',
  SMALL_TOOLTIP_TEXT: 'Используйте левую кнопку мыши или тачпада для вращения здания, и правую кнопку для перетаскивания здания',

  BLOCKS_COUNT: 'Кол-во блоков',
  BLOCKS_COUNT_2: 'Блоки',
  BLOCKS_STAGES: 'Этажи',
  BLOCKS_SQUARE: 'Площадь',

  SQUARE_POSTFIX: "м²",

  TOOLTIP_1_TITLE: 'Добавление контейнеров',
  TOOLTIP_1_TEXT: 'Нажимайте на плюсы для добавления новых контейнеров.',
  TOOLTIP_2_TITLE: 'Добавление объектов',
  TOOLTIP_2_TEXT: 'Перетаскивайте необходимые перегородки, окна, двери и другие объекты прямо на схему.',
  TOOLTIP_3_TITLE: 'Отмена действия',
  TOOLTIP_3_TEXT: 'Отменяйте предыдущие действия в любой момент.',
  TOOLTIP_4_TITLE: 'Этажи',
  TOOLTIP_4_TEXT: 'Переключайтесь между этажами, добавляйте или копируйте этажи.',
  TOOLTIP_5_TITLE: 'Сохранение заявки',
  TOOLTIP_5_TEXT: 'Скачайте PDF с Заявкой или отправьте Заявку себе на почту, вместе со ссылкой для дальнейшего редактирования.',
  TOOLTIP_6_TITLE: 'Скриншоты',
  TOOLTIP_6_TEXT: 'Сделайте скриншот получившейся схемы.',
  TOOLTIP_7_TITLE: 'Начать заново',
  TOOLTIP_7_TEXT: 'В любой момент можно начать новый проект.',
  TOOLTIP_8_TITLE: 'Детализация модульного здания',
  TOOLTIP_8_TEXT: 'Проверяйте состав модульного здания по разделам и управляйте деталями. В разделе “Доп. элементы” можно оставить особые указания для наших менеджеров.',
  TOOLTIP_9_TITLE: 'Режим просмотра готового здания',
  TOOLTIP_9_TEXT: 'Посмотрите как будет выглядеть ваше модульное здание в 3D.',
  TOOLTIP_10_TITLE: 'Оформление заказа',
  TOOLTIP_10_TEXT: 'Перейдите к оформлению заказа. Далее вы сможете указать адрес доставки и условия монтажа.',
  TOOLTIP_11_TITLE: 'Подсказки',
  TOOLTIP_11_TEXT: 'Воспользуйтесь подсказками в любой момент.',
  TOOLTIP_12_TITLE: 'Режим редактирования',
  TOOLTIP_12_TEXT: 'Для редактирования проекта перейдите в 2D-режим.',
  TOOLTIP_13_TITLE: 'Отделка',
  TOOLTIP_13_TEXT: 'Меняйте цвета каркаса и внешних стен контейнеров.',
  TOOLTIP_14_TITLE: 'Прозрачные стены',
  TOOLTIP_14_TEXT: 'Включите этот режим, чтобы видеть сквозь стены.',
  TOOLTIP_15_TITLE: 'Скриншоты',
  TOOLTIP_15_TEXT: 'Вы всегда можете сделать несколько скриншотов вашего модульного здания.',
  TOOLTIP_16_TITLE: 'Подсказки',
  TOOLTIP_16_TEXT: 'Воспользуйтесь подсказками в любой момент.',

  EQ_ITEM_CARCASS: 'Каркас',
  EQ_ITEM_EXT_FINISHING: 'Внешн. отделка',
  EQ_ITEM_ROOF: 'Кровля',
  EQ_ITEM_WINDOWS: 'Окна',
  EQ_ITEM_DOORS: 'Двери',
  EQ_ITEM_INT_FINISHING: 'Внутр. отделка',
  EQ_ITEM_FLOOR: 'Пол',
  EQ_ITEM_PLUMBING: 'Сантехника',
  EQ_ITEM_WARMING: 'Утепление',
  EQ_ITEM_WATERPROOF: 'Гидроизоляция',
  EQ_ITEM_ELECTRIC: 'Электрика',
  EQ_ITEM_ADDITIONAL: 'Доп. элементы',
  EQ_ITEM_MOUNTING: 'Монтаж',

  CONTAINER_TYPE_STANDARD: 'Стандарт',
  CONTAINER_TYPE_IMPROVED: 'Улучшенный',

  SANDWICH_PANEL_WALLS: 'Стены из сэндвич-панелей',
  WOODEN_WALLS: 'Стены с деревянной обрешёткой',

  MATERIALS_TAB_CARCASS: 'Каркас',
  MATERIALS_TAB_EXT: 'Снаружи',
  MATERIALS_TAB_ROOF: 'Крыша',

  ADDITIONAL_HEATER: 'Обогреватель',
  ADDITIONAL_HOOD: 'Вытяжка',
  ADDITIONAL_HAND_DRYER: 'Сушилка для рук',

  HEATING_BATTERY_INFO: 'Выбирайте батареи отопления только если на участок подведена горячая вода',
  MIXER_INCLUDED: 'В комплект уже входит смеситель',

  WOODEN_WINDOW: 'Деревянное окно',
  WOODEN_WINDOWS: 'Деревянные окна',
  PLASTIC_WINDOW: 'Пластиковое окно',
  PLASTIC_WINDOWS: 'ПЛАСТИКОВЫЕ',

  WINDOW: 'Окно',
  DOOR: 'Дверь',
  HOOD: 'Вытяжка',
  CONTAINER: 'Контейнер',
  SINK: 'Раковина',
  BOILER: 'Бойлер',
  TOILET: 'Туалет',
  SHOWER: 'Душ',
  HAND_DRYER: 'Сушилка для рук',
  HEATER: 'Обогреватель',
  LADDER: 'Лестница',
  BATTERY: 'Батарея',
  PARTITION: 'Перегородка',

  CONSTRUCTIONS: 'Конструкции',
  WINDOWS: 'Окна',
  DOORS: 'Двери',
  PLUMBING: 'Сантехника',
  SECOND_FLOOR: 'Второй этаж',
  FINISHING: 'Отделка',

  COST: 'Стоимость',

  TIME_FOR_PRODUCT: 'Время изготовления',
  LABEL_ORDER: 'Заказать',

  STAGE: 'Этаж',
  EDIT_MODE_DESCRIPTION: 'Перейдите в 2D режим для удобного редактирования проекта. В режиме 3D хорошо виден весь проект.',
  ADDITIONAL_COMMENTS: 'Здесь вы можете оставить дополнительные пожелания и комментарии',

  LABEL_SAVE: 'Сохранить',

  ORG_NAME: 'Название организации',
  ORG_TIN: 'ИНН',
  ORG_PERSON: 'Контактное лицо',
  PHONE: 'Телефон',
  EMAIL: 'E-mail',
  DELIVERY: 'Доставка',
  DELIVERY_DATE: 'Желаемая дата',
  DELIVERY_COST: 'Стоимость доставки:',
  DELIVERY_ADDRESSES: 'Адреса доставки',
  CRANE_UNLOADING: 'Разгрузка краном покупателя',
  MOUNTING: 'Монтаж',

  ERROR_FIELD_REQUIRED: 'Поле необходимо заполнить',

  PROJECT_NAME: 'Проект «Стандарт»',

  WOODEN_PROJECT: 'Контейнеры с деревянной обрешёткой',
  SANDWICH_PROJECT: 'Контейнеры сэндвичные',
  PRODUCTION_TIME: 'Срок изготовления',
  PRODUCTION_DAYS: '7 - 14 дней',

  DRAW_UP_PROJECT: 'Оформить',
  ORDER_COMPLETE: 'Заявка оформлена',
  ORDER_COMPLETE_DESCRIPTION: 'Заявка №{pid} успешно оформлена. Наш менеджер свяжется с вами в ближайшее время для подтверждения заказа. Копия заявки была отправлена на ваш e-mail.',
  DOWNLOAD_ORDER_PDF: 'Скачать заявку (PDF)',

  ENTER_ADDRESS: 'Введите адрес и нажмите "Enter"',
  FIND: 'Найти',
  LOCATION_TIP: '*Для более точного определения, маркер на карте можно перемещать',
  LABEL_APPLY: 'Применить',

  SEND_ON_EMAIL: 'Отправить на почту',

  HELP: 'Помощь',

  TRANSPARENT_WALLS: 'Прозрачные стены',
  HIDE_ROOF: 'Не показывать крышу',
  IMMERCYB: 'Сделано в Immersive Cybernetics',

  DOWNLOAD_SCREENSHOT: 'Скачать скриншот',
  SCREENSHOT_TIP: 'Вы можете изменить пропорции и размер скриншота. Изображение будет сохранено в формате JPEG.',

  DOWNLOAD: 'Скачать',

  FIRST_STEPS_TITLE: 'Перед тем как начать...',

  BACK: 'Назад',

  CHECKOUT_PROCESS: 'Оформление заказа',
  CHECKOUT_STEP: 'Шаг {step} из 2',

  SCHEDULE: 'пн-пт 8:00-19:00, сб 9:00-17:00',

  ORDER: 'Заявка',

  CORNER_POSTS: 'Угловые стойки',
  CARCASS_CHANNEL: 'Швеллер',
  CRATE: 'Обрешётка',
  COAT_TYPE: 'Тип кровли',
  METAL_TRUSSES: 'Металлические фермы',
  WALL_METALL: 'металл. лист 0.45 мм',
  CONTAINERS_DIFFERENT_COLOR: 'Разный цвет для<br/>отдельных контейнеров',
  CONTAINERS_DIFFERENT_COATING: 'Разное покрытие для<br/>отдельных контейнеров',
  CONTAINERS_DIFFERENT_MATERIAL: 'Разный материал для<br/>отдельных контейнеров',
  ROOM_PARTITION_TYPE: 'Тип внутренних перегородок',
  FLOOR_SUB: 'Дно',
  TILED_INSULATION: 'Плиточный утеплитель',
  PART_OF_PRICE: 'входит в стоимость',
  ADDITIONAL_LAGS: 'Дополнительные лаги',
  METAL_LAGS: 'Металлические лаги',
  CLEAN_FLOOR: 'Чистовой пол',
  COMMON_FLOOR: 'Основной пол',
  FLOOR_ADDITIONAL_LAYER: 'Дополнительный слой',
  NO_ELEMENTS: 'Нет добавленных элементов',
  STANDART: 'Стандарт',
  WARMING_TYPE: 'Тип утеплителя',
  WARMING_WIDTH: 'Толщина утеплителя',
  GYDRO_INSIDE_B: 'Гидропроф внутренний, Б',
  GYDRO_INSIDE_A: 'Гидропроф внутренний, А',
  GYDRO_EXT_A: 'Гидропроф внешний, А',
  GYDRO_EXT_A: 'Гидропроф внешний, Б',
  SOCKETS: 'Розетки',
  FOR_ONE_ITEM: 'за шт.',
  LIGHTING: 'ОСВЕЩЕНИЕ',
  ADDITIONAL_COMMENT_TEXT: 'Добавить доп. указания',
  CLIENT: 'Заказчик',
  PREPEARED_FLOOR: 'Черновой пол',
  ADDITIONAL_FLOOR: 'Дополнительное дно',
  FLOOR_ADITIONAL_METAL_LAGS: 'Кол-во доп металл лагов',
  PVC_FILM_40: 'Плёнка ПВХ 40мкр',
  BLOCK_CONTAINER: 'Блок-контейнер',

  DOORS_EXT: 'Внешние двери',
  DOORS_INT: 'Межкомнатные двери',
  DOORS_OTHER: 'Разное',

  INPUT_RAL: 'Введите номер RAL',

  TOOLTIP_3D: 'Используйте левую кнопку мыши или тачпада для вращения здания, и правую кнопку для перетаскивания здания',
  TOOLTIP_2D: 'Нажмите на контейнер, чтобы изменить его длину. Пока он выделен красным, тяните его за угол, чтобы растянуть или уменьшить длину контейнера'
}
